"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Pagination = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _Dropdown = _interopRequireDefault(require("../baseComponents/Dropdown"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Pagination = exports.Pagination = function Pagination(props) {
  //perPage props
  var values = props.values;
  var perPageValues = values.map(function (el, index) {
    return {
      "value": "".concat(el),
      "label": /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, el, " ", props.perPageText),
      "selected": el == props.perPage
    };
  });

  //pagination props
  var totalPages = Math.ceil(props.currentCount / props.perPage);
  if (totalPages === 0) totalPages = 1;
  var nextPageDisabled = props.page === totalPages;
  var disablePagination = props.disabled || false;
  var previousPageDisabled = props.page === 1;

  //React state hook
  var _useState = (0, _react.useState)(props.page),
    _useState2 = _slicedToArray(_useState, 2),
    userPage = _useState2[0],
    setUserPage = _useState2[1];
  //On change of value of page or props.limit, set userInput value to the calculated page
  (0, _react.useEffect)(function () {
    setUserPage(props.page);
  }, [props.page, props.limit]);
  function onUserInputChange(event) {
    // Validate user input
    if (isNaN(event.target.value)) return;
    var value = parseInt(event.target.value);
    if (value < 1) value = 1;
    if (value > totalPages) value = totalPages;
    props.onChange(event, props.perPage, value, "input");
  }
  ;
  var linkNext = "";
  var linkPrev = "";
  if (props.toLink) {
    if (!previousPageDisabled) {
      linkPrev = props.toLink.includes("?") ? "".concat(props.toLink) : "".concat(props.toLink, "?");
      linkPrev += "&page=".concat(props.page + -1, "&perPage=").concat(props.perPage);
    }
    if (!nextPageDisabled) {
      linkNext = props.toLink.includes("?") ? "".concat(props.toLink, "&") : "".concat(props.toLink, "?");
      linkNext += "page=".concat(props.page + 1, "&perPage=").concat(props.perPage);
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pagination-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "perPage-section col-xs-6"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    options: perPageValues,
    type: "custom",
    shapeSytle: "borderless",
    onChange: function onChange(event, input, option) {
      window.localStorage.setItem("pagination_component_init", option.value);
      props.onChange(event, parseInt(option.value), 1, "dropdown");
    }
  }), props.additionalComponent ? props.additionalComponent : null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pagination-section col-xs-6"
  }, totalPages === 1 ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "onePage"
  }, totalPages) : /*#__PURE__*/_react["default"].createElement("input", {
    disabled: disablePagination,
    onFocus: function onFocus(e) {
      e.target.select();
    },
    "data-test": "input",
    type: "text",
    onKeyDown: function onKeyDown(event) {
      if (event.keyCode === 13) {
        onUserInputChange(event);
      }
    },
    value: userPage,
    onChange: function onChange(e) {
      setUserPage(e.target.value);
    }
  }), props.ofText, " ", totalPages, props.toLink ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: linkPrev,
    title: "previous",
    className: "previousButton ".concat(previousPageDisabled ? "disabled" : ""),
    onClick: function onClick(e) {
      props.onChange(e, props.perPage, props.page - 1, "arrowDown");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head",
    className: "previous"
  })), /*#__PURE__*/_react["default"].createElement("a", {
    href: linkNext,
    title: "next",
    className: "next ".concat(nextPageDisabled ? "disabled" : ""),
    "data-test": "next",
    onClick: function onClick(e) {
      props.onChange(e, props.perPage, props.page + 1, "arrowUp");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head"
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "previousButton",
    disabled: previousPageDisabled || disablePagination,
    onClick: function onClick(e) {
      props.onChange(e, props.perPage, props.page - 1, "arrowDown");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head",
    className: "previous"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    disabled: nextPageDisabled || disablePagination,
    "data-test": "next",
    className: "next",
    onClick: function onClick(e) {
      props.onChange(e, props.perPage, props.page + 1, "arrowUp");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head"
  })))));
};
Pagination.propTypes = {
  perPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  values: _propTypes["default"].arrayOf(_propTypes["default"].number),
  ofText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onChange: _propTypes["default"].func,
  perPage: _propTypes["default"].number,
  page: _propTypes["default"].number,
  currentCount: _propTypes["default"].number,
  additionalComponent: _propTypes["default"].any,
  toLink: _propTypes["default"].string
};
Pagination.defaultProps = {
  perPageText: "perPage",
  values: [25, 50, 100],
  ofText: "of",
  perPage: 25,
  page: 1,
  currentCount: 1,
  onChange: function onChange() {},
  toLink: null
};
var _default = exports["default"] = Pagination;